var map = {
	"./af.json": 41,
	"./am.json": 42,
	"./ar.json": 43,
	"./az.json": 44,
	"./be.json": 45,
	"./bg.json": 46,
	"./bn.json": 47,
	"./br.json": 48,
	"./bs.json": 49,
	"./ca.json": 50,
	"./cs.json": 51,
	"./cy.json": 52,
	"./da.json": 53,
	"./de.json": 54,
	"./dv.json": 55,
	"./el.json": 56,
	"./en.json": 57,
	"./es.json": 58,
	"./et.json": 59,
	"./eu.json": 60,
	"./fa.json": 61,
	"./fi.json": 62,
	"./fr.json": 22,
	"./ga.json": 63,
	"./gl.json": 64,
	"./ha.json": 65,
	"./he.json": 66,
	"./hi.json": 67,
	"./hr.json": 68,
	"./hu.json": 69,
	"./hy.json": 70,
	"./id.json": 71,
	"./is.json": 72,
	"./it.json": 73,
	"./ja.json": 74,
	"./ka.json": 75,
	"./kk.json": 76,
	"./km.json": 77,
	"./ko.json": 78,
	"./ku.json": 79,
	"./ky.json": 80,
	"./lt.json": 81,
	"./lv.json": 82,
	"./mk.json": 83,
	"./ml.json": 84,
	"./mn.json": 85,
	"./mr.json": 86,
	"./ms.json": 87,
	"./nb.json": 88,
	"./nl.json": 89,
	"./nn.json": 90,
	"./no.json": 91,
	"./pl.json": 92,
	"./ps.json": 93,
	"./pt.json": 94,
	"./ro.json": 95,
	"./ru.json": 96,
	"./sd.json": 97,
	"./sk.json": 98,
	"./sl.json": 99,
	"./so.json": 100,
	"./sq.json": 101,
	"./sr.json": 102,
	"./sv.json": 103,
	"./sw.json": 104,
	"./ta.json": 105,
	"./tg.json": 106,
	"./th.json": 107,
	"./tr.json": 108,
	"./tt.json": 109,
	"./ug.json": 110,
	"./uk.json": 111,
	"./ur.json": 112,
	"./uz.json": 113,
	"./vi.json": 114,
	"./zh.json": 115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40;